import { render, staticRenderFns } from "./BaseMaterialDesignIcon.vue?vue&type=template&id=79d08604&scoped=true&"
import script from "./BaseMaterialDesignIcon.vue?vue&type=script&lang=js&"
export * from "./BaseMaterialDesignIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d08604",
  null
  
)

export default component.exports